import gql from 'graphql-tag';

export const PROVIDER_BOOKED_SESSIONS_SUBSCRIPTION = gql`
  subscription providerBookedSessions($providerId: Int!) {
    providerBookedSessions(providerId: $providerId) {
      providerId
      bookedSessions
      bookedHours
      targetSessions
    }
  }
`;
